"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function eq(a, b) {
    var idx = 0;
    if (a === b) {
        return true;
    }
    if (typeof a.equals === 'function') {
        return a.equals(b);
    }
    if (a.length > 0 && a.length === b.length) {
        for (; idx < a.length; idx += 1) {
            if (!eq(a[idx], b[idx])) {
                return false;
            }
        }
        return true;
    }
    return false;
}
exports.eq = eq;



//////////////////
// WEBPACK FOOTER
// ./lib/src/monad.js
// module id = 1
// module chunks = 0